import request from "../utils/request";
import {
    SEND_VERIFICATION_CODE_FROM_PASSWORD_TO_SET_SECURITY,
    GET_CAPTCHA_FROM_PASSWORD_TO_SET_SECURITY,
    VERIFY_PASSWORD_FROM_PASSWORD_TO_SET_SECURITY,
    SET_SECURITY_FROM_PASSWORD
} from "@/constants/apis";

export const getCaptcha = data => {
    return request({
        method: "get",
        url: GET_CAPTCHA_FROM_PASSWORD_TO_SET_SECURITY,
        data
    });
};

export const verifyPwd = data => {
    return request({
        url: VERIFY_PASSWORD_FROM_PASSWORD_TO_SET_SECURITY,
        data
    });
};

export const setSecurity = data => {
    let url = SET_SECURITY_FROM_PASSWORD.replace("<type>", data.type);
    return request({
        method: "put",
        url,
        data
    });
};

export const sendCode = data => {
    let url = SEND_VERIFICATION_CODE_FROM_PASSWORD_TO_SET_SECURITY.replace(
        "<type>",
        data.type
    );
    return request({
        url,
        data
    });
};
